import { render } from "./ApiTokens.vue?vue&type=template&id=496bb2ed&scoped=true"
import script from "./ApiTokens.vue?vue&type=script&lang=js"
export * from "./ApiTokens.vue?vue&type=script&lang=js"

import "./ApiTokens.vue?vue&type=style&index=0&id=496bb2ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496bb2ed"]])

export default __exports__